import ActionsMenu from '../../../../components/ActionsMenu';

export function EditorHeader({
    selectedFamily,
    isEditingName,
    editFamilyName,
    setEditFamilyName,
    setIsEditingName,
    savingFamilyName,
    onRenameFamily,
    onDeleteFamilyClick
}) {
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid var(--border)', paddingBottom: '1.5rem', flexShrink: 0 }}>
            {isEditingName ? (
                <form onSubmit={onRenameFamily} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <input 
                        className="input-field" 
                        value={editFamilyName} 
                        onChange={e => setEditFamilyName(e.target.value)} 
                        style={{ fontSize: '1.5rem', fontWeight: 700, padding: '0.25rem 0.5rem', margin: 0, width: '300px', background: 'var(--bg-primary)' }}
                        autoFocus
                        required
                    />
                    <button type="submit" disabled={savingFamilyName} style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: 'var(--success)', padding: '0.25rem' }} title="Save Name">
                        <i className="fa-solid fa-check" style={{ fontSize: '1.25rem' }}></i>
                    </button>
                    <button type="button" onClick={() => { setIsEditingName(false); setEditFamilyName(selectedFamily.name); }} style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: 'var(--error)', padding: '0.25rem' }} title="Cancel">
                        <i className="fa-solid fa-xmark" style={{ fontSize: '1.25rem' }}></i>
                    </button>
                </form>
            ) : (
                <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', minWidth: 0 }}>
                        <h2 style={{ fontSize: '1.75rem', fontWeight: 700, margin: 0, color: 'var(--text-primary)' }}>
                            {selectedFamily.name}
                        </h2>
                    </div>
                    <ActionsMenu
                        label="Family actions"
                        items={[
                            {
                                label: 'Rename Family',
                                icon: 'fa-solid fa-pen',
                                onSelect: () => setIsEditingName(true)
                            },
                            {
                                label: 'Delete Family',
                                icon: 'fa-solid fa-trash-can',
                                danger: true,
                                onSelect: onDeleteFamilyClick
                            }
                        ]}
                    />
                </div>
            )}
        </div>
    );
}
